import { render, staticRenderFns } from "./PdfDownloadTableAnchor.vue?vue&type=template&id=50297c2c&"
import script from "./PdfDownloadTableAnchor.vue?vue&type=script&lang=ts&"
export * from "./PdfDownloadTableAnchor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports